import { SkeletonCircle } from '@chakra-ui/react'

export const GuardAvatarsSkeleton = () => {
  return <SkeletonCircle size='24px' />
}
